import {
  DocumentSnapshot,
  SnapshotOptions,
  Timestamp,
} from 'firebase/firestore';
import { DeckId } from './deck.model';
import { UserId } from './user.model';
export type DeckLogId = string;

export class DeckLogEntry {
  id: DeckLogId;
  userId: UserId;
  deckId: DeckId;
  studyTime: number;
  totalFlashcards: number;
  wrongFlashcards: number;
  timestamp: Timestamp;

  constructor(
    id: string,
    userId: UserId,
    deckId: DeckId,
    studyTime: number,
    totalFlashcards: number,
    wrongFlashcards: number,
    timestamp: Timestamp
  ) {
    this.id = id;
    this.userId = userId;
    this.deckId = deckId;
    this.studyTime = studyTime;
    this.totalFlashcards = totalFlashcards;
    this.wrongFlashcards = wrongFlashcards;
    this.timestamp = timestamp;
  }
}

export const deckLogEntryConverter = {
  toFirestore: (deckLogEntry: DeckLogEntry) => {
    return {
      id: deckLogEntry.id,
      userId: deckLogEntry.userId,
      deckId: deckLogEntry.deckId,
      studyTime: deckLogEntry.studyTime,
      totalFlashcards: deckLogEntry.totalFlashcards,
      wrongFlashcards: deckLogEntry.wrongFlashcards,
      timestamp: deckLogEntry.timestamp,
    };
  },
  fromFirestore: (snapshot: DocumentSnapshot, options?: SnapshotOptions) => {
    if (!snapshot.exists()) {
      return undefined;
    }
    const data = snapshot.data(options);
    return new DeckLogEntry(
      snapshot.id,
      data['userId'],
      data['deckId'],
      data['studyTime'],
      data['totalFlashcards'],
      data['wrongFlashcards'],
      data['timestamp']
    );
  },
};
